import { ChangeEvent, memo, ReactNode, forwardRef } from 'react';
import cn from 'classnames';
import { DataTestId } from '@packages/shared/core/common/constants/dataTestId';
import styles from './Checkbox.module.scss';

type CheckboxProps = {
  main?: boolean;
  name: string;
  checked: boolean;
  children?: ReactNode;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  labelClassName?: string;
  dataTestId?: DataTestId;
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { name, children, checked, onChange, labelClassName = '', className = '', dataTestId = DataTestId.SMS_CONSENT },
    ref,
  ) => (
    <label className={styles.root} htmlFor={name}>
      <input
        type="checkbox"
        id={name}
        name={name}
        className={cn(styles.input, className)}
        checked={checked}
        onChange={onChange}
        data-testid={dataTestId}
        ref={ref}
      />

      <span className={cn('checkboxBox', styles.box)} aria-hidden />

      {children && <span className={cn(styles.content, labelClassName)}>{children}</span>}
    </label>
  ),
);

export default memo(Checkbox);
